package com.pincer.app.viewmodel

import com.pincer.app.ApplicationState
import com.pincer.app.I18n
import com.pincer.core.functions.readable
import com.pincer.core.functions.validateEmail
import com.pincer.core.functions.validateCode
import com.pincer.core.functions.validateCredential

fun getStarted(state: ApplicationState, context: Node) {
    context.node(key = "getStarted", prominence = Prominence.Primary) {
        if (state.transient.lockedPrincipal()) {
            val lockedMessage = if (state.transient.credentialCodeMayBeWrong) "wrongCode" else "lockedPrincipal"
            problem(lockedMessage) {
                node("details", I18n.translate("tryAgainIn", state.transient.lockedPrincipalRemainingMinutes().toString()))
            }
        }
        else if (state.transient.expectingCode) {
            node("credentialCode") {
                node(key = "message", wording = I18n.translate("credentialCodeHelpText", state.transient.claimedCredential!!))
                val problem = validateCode(state.transient.credentialCode)
                input(key = "principalConfirmCode", action = Action.PrincipalConfirmCode, wording = state.transient.credentialCode ?: "", problem = problem)
                possibleProblem(problem)
                helpText("sixDigitCode")
            }
        } else {
            node("withEmailAddress") {
                val problem = validateCredential(state.transient.claimedCredential)
                input(key = "principalTriggerCode", action = Action.PrincipalTriggerCode, wording = state.transient.claimedCredential ?: "", problem = problem)
                possibleProblem(problem)
            }
            /*
            node("withGoogle")
            node("withMicrosoft")
            node("withApple")
            */
        }
    }
}